module.exports = __webpack_public_path__ + "img/maincube_1.0a3492a0.jpg";